module.exports = __webpack_public_path__ + "static/media/Scherrie P.357509f5.jpeg";